<script>
  import { LayerCake, Html } from 'layercake';
  import AxisX from './components/AxisX.html.svelte';
  import AxisY from './components/AxisY.html.svelte';
  import FoodScatter from './components/FoodScatter.svelte';
  import Legend from './components/Legend.svelte';
  import Arrow from './components/Arrow.svelte';

  import { scaleLog } from 'd3-scale';
  import dataRaw from './lib/data.json';
  import { categoriesById } from './lib/categories';

  const data = JSON.parse(JSON.stringify(dataRaw))
  .filter(d => d.category !== 'vegetable oils')
  .filter(d => d.id !== 'weissmehl');
  data.forEach((d) => {
    d.co2_pro_portion /= 1000;
  });


  const xKey = 'preis_pro_portion_2021';
  const yKey = 'co2_pro_portion';
  const zKey = 'category';


  let hovered = null;

  function formatTickY(v, i) {
    let o = '' + v;
    o = o.replace('.', ',');
    if (i === 5) o += 'kg'; // CO₂<br>pro Portion';
    return o;
  } 

  function formatTickX(v) {
    return v + '€';
  }

  const labels = {
    'Rindersteak': { align: 'bottom'},
    'Joghurt': { align: 'top'},
    'Spargel': { align: 'top'},
    'Karotten': { align: 'bottom'},
    'Orangen': { align: 'top'},
    'Vollkornbrot': { align: 'top', hideMobile: true},
    'Erdbeeren': { align: 'bottom'},
    'Champignons': {
      align: 'right', 
      //extra: '5,37€ / 2,34kg CO₂'
      showValueX: '5,37€',
      showValueY: '2,34kg CO₂',
    },
    'Vollmilch': { align: 'top'},
    'Schweinefilet': { align: 'right'},
  };

</script>


<div class="scatterplot">
  <div class="scatterplot__legend">
    <Legend exclude={["vegetable oils"]} bind:hovered={hovered}/>
  </div>
  <div class="scatterplot__chart-container">
    <div class="grad grad-top-right"></div>
    <div class="grad grad-top-left"></div>
    <div class="grad grad-bottom-right"></div>
    <div class="grad grad-bottom-left"></div>
    <div class="label label-top-left">günstig und <br> klimaschädlich</div>
    <div class="label label-top-right">teuer und <br> klimaschädlich</div>
    <div class="label label-bottom-right">teuer und <br> klimafreundlich</div>
    <div class="label label-bottom-left">günstig und <br> klimafreundlich</div>

    <div class="axis-arrow-x">
      <Arrow direction="right"/>
    </div>

    <div class="axis-arrow-y">
      <Arrow direction="top"/>
    </div>
    <div class="axis-label-x">Preis pro Portion</div>
    <div class="axis-label-y">CO₂ pro Portion</div>

    <div class="scatterplot__chart">
      <LayerCake
        ssr={true}
        percentRange={true}
        padding={{ top: 0, right: 10, bottom: 20, left: 5 }}
        x={xKey}
        y={yKey}
        data={data}
        xScale={scaleLog()}
        yScale={scaleLog()}
        yDomain={[0.12, 18]}
        xDomain={[0.6, 25]}
      >

        <Html>
          <AxisX ticks={[1, 2, 4, 8, 16]} formatTick={formatTickX} minorTicks={[3,5,6,7,9,10,11,12,13,14,15,17,18,19,20,21,22,23,24]} />
          <AxisY labelsRight={true} ticks={[0.25, 0.5, 1, 2, 4, 8]} formatTick={formatTickY} minorTicks={[1.5, 2.5, 3, 3.5, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8.5, 9, 10, 11, 12, 13, 14, 15, 16, 16, 17, 18]}/>


          <FoodScatter {labels} {hovered} />
        </Html>

      </LayerCake>

    </div>
  </div>
</div>

<style>

  .scatterplot {
    background: #dedede;
    border-radius: 6px;
    font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 20px;
  }

  .scatterplot__legend {
    padding: 20px 5px;
    background: #ededed;
    border-radius: 6px 6px 0 0;
  }

  .scatterplot__chart-container {
    padding: 10px 10px 40px 38px;
    position: relative;
  }

  .scatterplot__chart {
    width: 100%;
    height: 600px;
    position: relative;
  }

  .label {
    position: absolute;
    color: #1f1f1f;
    padding: 8px;
    pointer-events: none;
    user-select: none;
    font-size: 16px;
    line-height: 18px;
    font-weight: 500;
    z-index: 1;
  }

  .label-top-right {
    right: 0;
    top: 0;
    text-align: right;
  }

  .label-top-left {
    left: 0;
    top: 0;
    text-align: left;
  }
  .label-bottom-right {
    right: 0;
    bottom: 0;
    text-align: right;
  }
  .label-bottom-left {
    left: 0;
    bottom: 0;
    text-align: left;
  }

  .grad {
    position: absolute;
    pointer-events: none;
    user-select: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .grad-top-right {
    right: 0;
    top: 0;
    text-align: right;
    background: linear-gradient(to bottom left, rgba(7, 245, 158, 1) 0%, rgba(7, 245, 158, 0.3) 10%, rgba(7, 245, 158, 0) 40%);
    opacity: 0.06;
  }

  .grad-top-left {
    left: 0;
    top: 0;
    text-align: left;
    background: linear-gradient(to bottom right, rgba(245, 7, 98, 1) 0%, rgba(245, 7, 98, 0.3) 10%, rgba(245, 7, 98, 0) 40%);
    opacity: 0.06;
  }
  .grad-bottom-right {
    right: 0;
    bottom: 0;
    text-align: right;
    background: linear-gradient(to top left, rgba(245, 7, 98, 1) 0%, rgba(245, 7, 98, 0.3) 10%, rgba(245, 7, 98, 0) 40%);
    opacity: 0.25;
  }
  .grad-bottom-left {
    left: 0;
    bottom: 0;
    text-align: left;
    background: linear-gradient(to top right, rgba(7, 245, 158, 1) 0%, rgba(7, 245, 158, 0.3) 10%, rgba(7, 245, 158, 0) 40%);
    opacity: 0.25;
  }


  .axis-arrow-x {
    position: absolute;
    bottom: 17px;
    left: 140px;
    right: 140px;
  }

  .axis-arrow-y {
    position: absolute;
    left: 19px;
    top: 60px;
    bottom: 60px;
  }

  .axis-label-x {
    position: absolute;
    pointer-events: none;
    user-select: none;
    bottom: 2px;
    left: calc(50% + 7px);
    color: #333;
    transform: translateX(-50%);
    font-size: 12px;
  }

  .axis-label-y {
    position: absolute;
    pointer-events: none;
    user-select: none;
    left: -14px;
    top: 50%;
    color: #333;
    transform: rotate(-90deg) translateY(-50%);
    transform-origin: center center;
    font-size: 12px;
  }

  @media (max-width: 830px) {
    .scatterplot__chart-container {
      padding-bottom: 65px;
    }

    .axis-label-x {
      bottom: 37px;
    }
  }

  @media (max-width: 480px) {
    .scatterplot__chart {
      height: 480px;
    }
  }

  @media (max-width: 600px) {
    .axis-arrow-x {
      left: 20px;
      right: 20px;
      bottom: 47px;
    }

    .axis-arrow-y {
      left: 13px;
    }
    .axis-label-y {
      left: -19px;
    }
    .scatterplot__chart-container {
      padding-bottom: 70pxpx;
    }
    .axis-label-x {
      bottom: 33px;
    }
  }

</style>
